import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JwtHelper } from '../helpers/jwtDecode.helper';
import { IdentificacaoCpfCnpj } from '../models/enums/identificacao-cpf-cnpj.enum';
import { tipoLogradouros } from '../helpers/logradouro.helper';

@Injectable({
  providedIn: 'root'
})
export class ClienteFormService {
  identificacaoCpfCnpj: string = '';
  identificacoesCpfCnpjs: any[] = [
    { nome: 'CPF', tipo: IdentificacaoCpfCnpj.Cpf },
    { nome: 'CNPJ', tipo: IdentificacaoCpfCnpj.Cnpj },
  ];
  maxCpfCnpjLength: number = 14;
  tipoLogradouros = tipoLogradouros;

  constructor(
    private fb: FormBuilder,
    private jwtHelper: JwtHelper
  ) { }

  createForm(): FormGroup {
    const usuarioId = this.jwtHelper.getUserIdFromToken() || '';

    return this.fb.group({
      apelido: ['', Validators.required],
      razaoSocial: [''],
      nomeRazaoSocial: [''],
      tipoIdentificacaoCpfCnpj: [{ value: IdentificacaoCpfCnpj.Cnpj, disabled: true }, Validators.required],
      cpfCnpj: ['', [Validators.required, Validators.minLength(18), Validators.maxLength(18)]],
      telefone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      tipoLogradouro: [''],
      inscricaoMunicipal: ['', [Validators.minLength(7), Validators.maxLength(15)]],
      logradouro: ['', Validators.required],
      numero: ['', Validators.required],
      complemento: [''],
      bairro: ['', Validators.required],
      municipio: [''],
      cep: ['', Validators.required],
      uf: ['', Validators.required],
      codigoMunicipio: ['', Validators.required],
      pais: ['', Validators.required],
      usuarioId: [usuarioId],
      faturamentosId: [[]],
    })
  }
}
